module.exports = __webpack_public_path__ + "img/cn-header.f1c23b74.png";